import * as React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { settingActions, settingObj } from '../store/SettingSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import * as JSTool from '../store/JSTool';

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import { Autoplay, EffectFade } from 'swiper/modules';

import TitleView from '../component/TitleView';

export default function HeroDetail_m(props) {
    const dispatch = useDispatch();
    const settingData = useSelector(state => state.settingData);
    const [swiper, setSwiper] = React.useState(null);

    React.useEffect(() => {
        dispatch(settingActions.setStellars(true));
    }, []);

    return (
        <Stack sx={{
            width: 1,
            height: settingData.innerHeight,
            alignItems: 'center',
            justifyContent: 'center',

            backgroundImage: `url(${JSTool.getImgPath('test1.png')})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'bottom center',
            backgroundSize: 'cover',
            overflow: 'hidden'
        }}>

            <Stack sx={{
                position: 'absolute',
                width: 1,
                top: '-30rem',
                alignItems: 'center',
            }}>
                <Stack sx={{ flexDirection: 'row' }}> <TitleView title='Summons' mt={'80rem'} /></Stack>

                <Box
                    component={'div'}
                    sx={{
                        fontSize: '25rem',
                        color: 'white',
                        fontWeight: 'bold',
                        fontFamily: window.font0,
                        opacity: 0.8,
                        textShadow: '2px 2px 6px #26A8E0',
                        display: settingData.isMobile ? 'block' : 'none',
                        textAlign: 'center',
                        mt: 2,
                    }}
                    dangerouslySetInnerHTML={{
                        __html:
                            `
     Asters are fragments of the heroes' <br/>souls in the Mirren history.  <br/> They can embody the Novas <br/>and carry out the Novas' commands.
         `
                    }} />
            </Stack>


            <Box component={'img'}
                sx={{
                    height: 1,
                    maxHeight: window.innerHeight * 0.7,
                    objectFit: 'contain',
                }}
                src={JSTool.getImgPath(`stellars/${settingData.roleItem.name}_img.png`)} />

            <LeftView />

        </Stack>
    );
}

function BackView(props) {
    const navigate = useNavigate();

    function backTap() {
        navigate('/');
    }

    return (
        <Stack
            onClick={backTap}
            sx={{
                flexDirection: 'row',
                position: 'absolute',
                left: 0,
                top: '180rem',
                alignItems: 'center',
                cursor: 'pointer',
                transitionDuration: '0.3s',
                '&:hover': {
                    transform: 'scale(1.1)'
                }
            }}>

            <Box component={'img'}
                sx={{
                    height: '30rem',
                }}
                src={JSTool.getImgPath('news_left.png')} />

            <Stack sx={{
                alignItems: 'center',
                zIndex: 1,
                position: 'relative',
                flexDirection: 'row',
                height: '45rem',
            }}>
                <Stack sx={{
                    position: 'absolute',
                    flexDirection: 'row',
                    height: 1,
                    width: 1,
                    top: 0,
                    left: 0,
                    justifyContent: 'center',
                    zIndex: 1,
                }}>

                    <Box sx={{
                        width: '10rem',
                        background: 'linear-gradient(90deg, #00000000 , #000000bb)',
                    }} />
                    <Box sx={{
                        flex: 1,
                        background: '#000000bb',
                    }} />
                    <Box sx={{
                        width: '45rem',
                        background: 'linear-gradient(-90deg, #00000000 , #000000bb)',
                    }} />
                </Stack>

                <Typography
                    sx={{
                        px: 2,
                        zIndex: 2,
                        width: 1,
                        height: 1,
                        lineHeight: '45rem',
                        textAlign: 'center',
                        fontSize: '20rem',
                        color: 'white',
                        fontFamily: window.font0,
                    }}>
                    Back
                </Typography>

            </Stack>



        </Stack>
    );
}


function LeftView(props) {
    const settingData = useSelector(state => state.settingData);

    return (
        <Stack sx={{
            alignItems: 'center',
            zIndex: 1,
            position: 'absolute',
            left: 0,
            bottom: '50rem',
            maxWidth: '480rem',
            px: 3,
            py: 1,
        }}>
            <Stack sx={{
                position: 'absolute',
                flexDirection: 'row',
                height: 1,
                width: 1,
                top: 0,
                left: 0,
                justifyContent: 'center',
                zIndex: 1,
            }}>

                <Box sx={{
                    width: '30rem',
                    background: 'linear-gradient(90deg, #00000000 , #000000c0)',
                }} />
                <Box sx={{
                    flex: 1,
                    background: '#000000c0',
                }} />
                <Box sx={{
                    width: '100rem',
                    background: 'linear-gradient(-90deg, #00000000 , #000000c0)',
                }} />
            </Stack>


            <Stack sx={{
                zIndex: 2,
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'start',
                width: 1,
            }}>

                <Box component={'img'}
                    src={JSTool.getImgPath('stellars/yetannia_icon.png')}
                    sx={{
                        height: '60rem'
                    }} />

                <Typography
                    sx={{
                        fontSize: '30rem',
                        color: 'white',
                        fontFamily: window.font0,
                        opacity: 0.9,
                        ml: 1,
                    }}>
                    {JSTool.capitalize(settingData.roleItem.name)}
                </Typography>

                <Typography
                    sx={{
                        fontSize: '20rem',
                        color: 'white',
                        fontFamily: window.font0,
                        opacity: 0.9,
                        ml: 2,
                    }}>
                    ({settingData.roleItem.nick})
                </Typography>

            </Stack>


            {/* 自动换行 */}
            <Typography
                sx={{
                    zIndex: 2,
                    width: 1,
                    maxWidth: 1,
                    fontSize: '14rem',
                    color: 'white',
                    fontFamily: window.font0,
                    opacity: 0.9,
                    wordBreak: 'break-word',
                    wordWrap: 'break-word',
                    overflowWrap: 'break-word',
                }}>
                {settingData.roleItem.info}
            </Typography>

        </Stack>
    );
}


function RightView(props) {
    const [swp, setSwp] = React.useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const settingData = useSelector(state => state.settingData);

    function leftTap() {
        if (swp) {
            swp.slidePrev();
        }
    }

    function rightTap() {
        if (swp) {
            swp.slideNext();
        }
    }

    function indexChanged() {

    }

    return (
        <Stack sx={{
            position: 'absolute',
            right: 0,
            display: 'none',
            flexDirection: 'row',
            alignItems: 'center',
            width: '130rem',
            bottom: '20rem',
            right: 0,
        }}>

            <Swiper style={{
                width: '100%',
                padding: 0,
                margin: 0,
            }}
                slidesPerView={1}
                centeredSlides={true}

                onSlideChangeTransitionEnd={(sp) => {
                    indexChanged();
                }}

                onSwiper={(swiper) => {
                    setSwp(swiper);
                    swiper.slideTo(0);
                }}>

                {
                    JSTool.RoleAry.map((item, index) => {
                        return <SwiperSlide key={index}><Item index={index} item={item} /></SwiperSlide>
                    })
                }

            </Swiper>

            {/* 左右按钮 */}
            <Stack sx={{
                position: 'absolute',
                left: 0,
                height: 1,
                width: '100rem',
                zIndex: 3,
                // background: 'linear-gradient(90deg, #000000cc , #00000000)',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                <Box
                    onClick={leftTap}
                    component={'img'}
                    src={JSTool.getImgPath('news_left.png')}
                    sx={{
                        width: '35rem',
                        mr: '20rem',
                        cursor: 'pointer',
                        transitionDuration: '0.3s',
                        '&:hover': {
                            transform: 'scale(1.3)'
                        }
                    }} />

            </Stack>

            <Stack sx={{
                position: 'absolute',
                right: 0,
                height: 1,
                width: '100rem',
                zIndex: 3,
                // background: 'linear-gradient(90deg, #00000000 , #000000cc)',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                <Box
                    onClick={rightTap}
                    component={'img'}
                    src={JSTool.getImgPath('news_right.png')}
                    sx={{
                        width: '35rem',
                        ml: '25rem',
                        cursor: 'pointer',
                        transitionDuration: '0.3s',
                        '&:hover': {
                            transform: 'scale(1.3)'
                        }
                    }} />
            </Stack>

        </Stack>
    );
}

function Item(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();


    function itemTap() {
        dispatch(settingActions.setRoleItem(props.item));
        navigate('/role_detail');
    }

    return (
        <Stack
            onClick={itemTap}
            sx={{
                width: '130rem',
                position: 'relative',
                py: '20rem',
                cursor: 'pointer',
                transitionDuration: '0.3s',
                '&:hover': {
                    transform: 'scale(1.0.5)',
                },
            }}>
            <Box component={'img'}
                src={JSTool.getImgPath(`stellars/${props.item.name}_big.png`)}
                sx={{
                    width: 1,
                    // filter: 'drop-shadow(0px 0px 15px #745ff299)',
                }} />

            <Box component={'img'}
                src={JSTool.getImgPath(`stellars/${props.item.name}_icon.png`)}
                sx={{
                    position: 'absolute',
                    width: '40rem',
                    bottom: '45rem',
                    left: '13rem'
                }} />

            <Box
                component={'div'}
                sx={{
                    position: 'absolute',
                    color: 'white',
                    fontSize: '12rem',
                    fontWeight: 'bold',
                    bottom: '60rem',
                    left: '55rem',
                    fontFamily: window.font0,
                    transform: 'skewY(-10deg)',
                }}
                dangerouslySetInnerHTML={{
                    __html:
                        `${JSTool.capitalize(props.item.name)}<br/>${props.item.nick}`,
                }} />

        </Stack>
    );
}
